import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorBankNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IBankModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IBankFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useBankHookNae(id: number) : IBankModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorBankNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Bank.schema,
        fields: IBankFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
